export default {
  setVendedor({ commit }, payload) {
    commit('setVendedor', payload)
  },

  setEmpresa({ commit }, payload) {
    commit('setEmpresa', payload)
  },

  setGrupo({ commit }, payload) {
    commit('setGrupo', payload)
  },

  setMidia({ commit }, payload) {
    commit('setMidia', payload)
  }
}
